// extracted by mini-css-extract-plugin
export default {"forNarrowClass":"styles_forNarrowClass__3ieOr","checkIcon":"styles_checkIcon__XBgbr"};